$(function(){
	var opts = {
		center: {
                    lat:35.693026301239925,
                    lng:139.769563459282
		},
		zoom: 17,
		styles: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","stylers":[{"visibility":"on"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"transit.station","elementType":"labels.icon","stylers":[{"visibility":"simplified"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}],
		maxZoom: 20,
		minZoom: 0,
		mapTypeId: 'roadmap',
		gestureHandling: 'cooperative'
	};


		opts.clickableIcons = true;
        opts.disableDoubleClickZoom = false;
        opts.draggable = true;
        opts.keyboardShortcuts = true;
        opts.scrollwheel = true;
	

	var setControlOptions = function(key, enabled, position, style, mapTypeIds){
		opts[key + 'Control'] = enabled;
		opts[key + 'ControlOptions'] = {
			position: google.maps.ControlPosition[position],
			style: google.maps.MapTypeControlStyle[style],
			mapTypeIds: mapTypeIds
		};
	};
	
	setControlOptions('fullscreen',false,'DEFAULT','',null);
	
	setControlOptions('mapType',false,'DEFAULT','DEFAULT',["roadmap","satellite","terrain"]);
	
	setControlOptions('rotate',false,'DEFAULT','',null);
	
	setControlOptions('scale',false,'','',null);
	
	setControlOptions('streetView',false,'DEFAULT','',null);
	
	setControlOptions('zoom',false,'DEFAULT','',null);
	
	var map = new google.maps.Map(document.getElementById('map'), opts);


	(function(){
		var markerOptions = {
			map: map,
			position: {
                            lat:35.693026301239925,
                            lng:139.769563459282
			}
		};

		markerOptions.icon = {
			url: '/images/map/google_mao_pin_icon.png',
			scaledSize: new google.maps.Size(
				36,
				36),
			size: new google.maps.Size(
				36,
				36),
			anchor: new google.maps.Point(
				18,
				36)
		};
		markerOptions.options = {
			optimized: true,
		};
		var marker = new google.maps.Marker(markerOptions);


	})();
	
})
